<template>
  <div class="group-management">
    <div class="card">
      <h1>用户组管理</h1>
      <button class="btn btn-primary" @click="showAddGroupDialog = true">添加组</button>
      
      <table class="data-table">
        <thead>
          <tr>
            <th>组名</th>
            <th>描述</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="group in groups" :key="group.id">
            <td>{{ group.name }}</td>
            <td>{{ group.description }}</td>
            <td>
              <button class="btn btn-small" @click="editGroup(group)">编辑</button>
              <button class="btn btn-small btn-danger" @click="deleteGroup(group.id)">删除</button>
            </td>
          </tr>
        </tbody>
      </table>
      
      <!-- 添加组弹窗 -->
      <div v-if="showAddGroupDialog" class="dialog-overlay" @click.self="closeAddDialog">
        <div class="dialog">
          <div class="dialog-header">
            <h3>添加组</h3>
            <button class="dialog-close" @click="closeAddDialog">&times;</button>
          </div>
          <div class="dialog-content">
            <form @submit.prevent="submitAddGroup" class="form">
              <div class="form-group">
                <label>组名</label>
                <input 
                  v-model="newGroup.name" 
                  class="form-input" 
                  placeholder="组名" 
                  required
                >
                <div v-if="errors.name" class="error-message">{{ errors.name }}</div>
              </div>
              <div class="form-group">
                <label>描述</label>
                <input 
                  v-model="newGroup.description" 
                  class="form-input" 
                  placeholder="描述" 
                  required
                >
                <div v-if="errors.description" class="error-message">{{ errors.description }}</div>
              </div>
            </form>
          </div>
          <div class="dialog-footer">
            <button class="btn" @click="closeAddDialog">取消</button>
            <button class="btn btn-primary" @click="submitAddGroup">保存</button>
          </div>
        </div>
      </div>
      
      <!-- 编辑组弹窗 -->
      <div v-if="dialogVisible" class="dialog-overlay" @click.self="cancelEdit">
        <div class="dialog">
          <div class="dialog-header">
            <h3>编辑组</h3>
            <button class="dialog-close" @click="cancelEdit">&times;</button>
          </div>
          <div class="dialog-content">
            <form @submit.prevent="updateGroup" class="form" v-if="editingGroup">
              <div class="form-group">
                <label>组名</label>
                <input 
                  v-model="editingGroup.name" 
                  class="form-input" 
                  placeholder="组名" 
                  required
                >
                <div v-if="errors.editName" class="error-message">{{ errors.editName }}</div>
              </div>
              <div class="form-group">
                <label>描述</label>
                <input 
                  v-model="editingGroup.description" 
                  class="form-input" 
                  placeholder="描述" 
                  required
                >
                <div v-if="errors.editDescription" class="error-message">{{ errors.editDescription }}</div>
              </div>
            </form>
          </div>
          <div class="dialog-footer">
            <button class="btn" @click="cancelEdit">取消</button>
            <button class="btn btn-primary" @click="updateGroup">保存</button>
          </div>
        </div>
      </div>
      
      <!-- 消息提示组件 -->
      <div v-if="message.show" class="message-toast" :class="message.type">
        {{ message.text }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      groups: [],
      newGroup: {
        name: '',
        description: ''
      },
      editingGroup: null,
      dialogVisible: false,
      showAddGroupDialog: false,
      errors: {},
      message: {
        show: false,
        text: '',
        type: 'success'
      }
    };
  },
  created() {
    this.fetchGroups();
  },
  methods: {
    // 显示消息提示
    showMessage(text, type = 'success') {
      this.message = { show: true, text, type };
      setTimeout(() => {
        this.message = { show: false, text: '', type: 'success' };
      }, 3000);
    },
    
    // 验证添加表单
    validateAddForm() {
      let isValid = true;
      this.errors = {};
      
      if (!this.newGroup.name || this.newGroup.name.trim() === '') {
        this.errors.name = '请输入组名';
        isValid = false;
      }
      
      if (!this.newGroup.description || this.newGroup.description.trim() === '') {
        this.errors.description = '请输入描述';
        isValid = false;
      }
      
      return isValid;
    },
    
    // 验证编辑表单
    validateEditForm() {
      let isValid = true;
      this.errors = {};
      
      if (!this.editingGroup || !this.editingGroup.name || this.editingGroup.name.trim() === '') {
        this.errors.editName = '请输入组名';
        isValid = false;
      }
      
      if (!this.editingGroup || !this.editingGroup.description || this.editingGroup.description.trim() === '') {
        this.errors.editDescription = '请输入描述';
        isValid = false;
      }
      
      return isValid;
    },
    
    async fetchGroups() {
      try {
        const response = await axios.get('/api/groups');
        this.groups = response.data;
        console.info(this.groups);
        console.log('Fetched groups:', this.groups);
      } catch (error) {
        console.error('获取用户组失败', error);
        this.showMessage('获取用户组失败', 'error');
      }
    },
    
    async submitAddGroup() {
      if (!this.validateAddForm()) {
        return;
      }
      
      try {
        await axios.post('/api/groups', this.newGroup);
        this.newGroup.name = '';
        this.newGroup.description = '';
        this.fetchGroups();
        this.showAddGroupDialog = false;
        this.showMessage('用户组添加成功');
      } catch (error) {
        if (error.response && error.response.data && error.response.data.detail) {
          this.showMessage(error.response.data.detail, 'error');
        } else {
          this.showMessage('用户组添加失败，请检查输入信息', 'error');
        }
      }
    },
    
    closeAddDialog() {
      this.showAddGroupDialog = false;
      this.errors = {};
    },
    editGroup(group) {
      this.editingGroup = { ...group };
      console.log('Editing group:', this.editingGroup);
      this.dialogVisible = true;
    },
    async updateGroup() {
      if (!this.validateEditForm()) {
        return;
      }
      
      try {
        console.log('Updating group with ID:', this.editingGroup.id);
        const response = await axios.put(`/api/groups/${this.editingGroup.id}`, this.editingGroup);

        // 更新本地的 groups 数据
        const updatedGroup = response.data;
        const index = this.groups.findIndex(group => group.id === updatedGroup.id);
        if (index !== -1) {
          this.groups.splice(index, 1, updatedGroup);
        }

        // 关闭对话框
        this.dialogVisible = false;

        // 清空编辑组数据
        this.editingGroup = null;
        this.errors = {};
        
        this.showMessage('用户组更新成功');
        console.log('Group updated successfully:', updatedGroup);
      } catch (error) {
        console.error('更新用户组失败', error);
        this.showMessage('更新用户组失败', 'error');
      }
    },
    cancelEdit() {
      this.editingGroup = null;
      this.dialogVisible = false;
    },
    async deleteGroup(id) {
      if (confirm('确定要删除这个用户组吗？')) {
        try {
          console.log('Deleting group with ID:', id);
          await axios.delete(`/api/groups/${id}`);
          this.fetchGroups();
          this.showMessage('用户组删除成功');
        } catch (error) {
          console.error('删除用户组失败', error);
          this.showMessage('删除用户组失败', 'error');
        }
      }
    }
  }
};
</script>

<style scoped>
/* 组管理页面样式 */
.group-management {
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 卡片样式 */
.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.card h1 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  font-size: 24px;
}

/* 表格样式 */
.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.data-table th,
.data-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e8e8e8;
}

.data-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 500;
}

.data-table tr:hover {
  background-color: #f5f7fa;
}

/* 按钮样式 */
.btn {
  padding: 8px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  margin-right: 10px;
}

.btn:hover {
  color: #409eff;
  border-color: #c6e2ff;
}

.btn-primary {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}

.btn-primary:hover {
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}

.btn-small {
  padding: 4px 12px;
  font-size: 12px;
  margin-right: 8px;
}

.btn-danger {
  color: #fff;
  background-color: #f56c6c;
  border-color: #f56c6c;
}

.btn-danger:hover {
  background-color: #f78989;
  border-color: #f78989;
  color: #fff;
}

/* 对话框样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog {
  background: #fff;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  animation: dialogFadeIn 0.3s ease-out;
}

.dialog-header {
  padding: 20px;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-header h3 {
  margin: 0;
  color: #333;
}

.dialog-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #909399;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.dialog-close:hover {
  background-color: #f5f7fa;
  color: #606266;
}

.dialog-content {
  padding: 20px;
}

.dialog-footer {
  padding: 15px 20px;
  border-top: 1px solid #e8e8e8;
  display: flex;
  justify-content: flex-end;
}

/* 表单样式 */
.form {
  width: 100%;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #606266;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.form-input:focus {
  outline: none;
  border-color: #409eff;
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 4px;
}

/* 消息提示样式 */
.message-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 4px;
  color: #fff;
  z-index: 2000;
  animation: slideInRight 0.3s ease-out;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.message-toast.success {
  background-color: #67c23a;
}

.message-toast.error {
  background-color: #f56c6c;
}

/* 动画效果 */
@keyframes dialogFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .group-management {
    padding: 10px;
  }
  
  .data-table {
    font-size: 14px;
  }
  
  .data-table th,
  .data-table td {
    padding: 8px;
  }
  
  .dialog {
    width: 95%;
  }
}
</style>
